import { LoadingButton } from '@issuemanager/apps/client/components';
import { Button, ButtonProps, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  isLoading: boolean;
  cancelButton?: ButtonProps;
  actionButton: ButtonProps;
  actionButtonText: string;
  onSend: () => void;
  onCancel: () => void;
};

export function Footer(props: Props) {
  const {
    isLoading,
    cancelButton,
    actionButton,
    actionButtonText,
    onSend,
    onCancel,
  } = props;
  const { t } = useTranslation(['common']);

  return (
    <Stack flexDirection='row' justifyContent='flex-end' gap={1.5} flexGrow={2}>
      <Button
        {...cancelButton}
        onClick={onCancel}
        aria-haspopup='true'
        variant='text'
      >
        {t('form.cancel')}
      </Button>
      <LoadingButton
        {...actionButton}
        variant='contained'
        onClick={onSend}
        aria-haspopup='true'
        loading={isLoading}
      >
        {actionButtonText}
      </LoadingButton>
    </Stack>
  );
}
